export default "__VITE_ASSET__2b1c4cf4__"